import React from "react";
import { Route, Switch } from "react-router-dom";
import * as QueriesQL from "queries/blog-post";
import BlogPostPublicSchema from "@common/schema/blog-post/public";
import * as Section from "@repoflow/components/section";
import { Crumb, useCrumbLabel } from "@repoflow/components/breadcrumb";
import * as ViewRoute from "./view";
import * as EditRoute from "./edit";
import * as RemoveRoute from "./remove";

const LocalProvider = ({
  match: {
    params,
    params: { postId },
  },
  children: Children,
}) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/${postId}`;
  const basepath = `${parentBasepath}/:postId`;

  return (
    <Section.Provider
      key={postId}
      schema={BlogPostPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ params }) => (
        <Section.Query
          query={QueriesQL.get}
          variables={params}
          datapath={"sites.get.blog.posts.get"}
        >
          {ContentHandler}
        </Section.Query>
      )}
    </LocalProvider>
  );
}

function ContentHandler({ basepath }) {
  return (
    <Switch>
      <Route path={`${basepath}/remove`} component={RemoveRoute.Content} />
      <Route path={`${basepath}/edit`} component={EditRoute.Content} />
      <Route path={`${basepath}`} component={ViewRoute.Content} />
    </Switch>
  );
}

// A post's id is a uuid, so the crumb is its title — the same read the page's
// crumb makes, off the cache the screen beneath it has already filled.
const PostCrumb = ({ base, siteId, postId }) => {
  const label = useCrumbLabel({
    query: QueriesQL.get,
    variables: { siteId, postId },
    datapath: "sites.get.blog.posts.get.title",
    fallback: postId,
  });

  return <Crumb to={base} label={label} />;
};

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath, params: { siteId, postId } }) => (
        <>
          <PostCrumb base={base} siteId={siteId} postId={postId} />
          <Switch>
            <Route path={`${basepath}/remove`} component={RemoveRoute.Indice} />
            <Route path={`${basepath}/edit`} component={EditRoute.Indice} />
            <Route path={`${basepath}`} component={ViewRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => null;
